import { MapPin } from "lucide-react";

const liegeCities = ["Liège", "Seraing", "Herstal", "Verviers", "Huy", "Visé", "Waremme", "Ans"];
const limbourgCities = ["Hasselt", "Genk", "Tongres", "Saint-Trond", "Bilzen", "Maaseik", "Lommel", "Beringen"];

export default function Zones() {
  return (
    <section id="zones" className="section-pad">
      <div className="grid lg:grid-cols-12 gap-10 mb-16">
        <div className="lg:col-span-6">
          <div className="eyebrow mb-6">Zones d'intervention</div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-light leading-[1]">
            Province de Liège<br />
            & <span className="italic text-[hsl(var(--accent))]">Limbourg belge</span>.
          </h2>
          <p className="mt-8 text-muted-foreground max-w-lg leading-relaxed">
            Akay intervient sur l'ensemble des provinces de Liège et du Limbourg. Demandez-nous —
            nous étudions toute demande à proximité.
          </p>
        </div>
        <div className="lg:col-span-6 grid sm:grid-cols-2 gap-6">
          {[
            { title: "Province de Liège", cities: liegeCities },
            { title: "Province de Limbourg", cities: limbourgCities },
          ].map((zone, i) => (
            <div
              key={i}
              data-testid={`zone-${i}`}
              className="border border-border rounded-sm p-7 bg-card/40 hover:border-[hsl(var(--accent))] transition-colors"
            >
              <div className="flex items-center gap-3 mb-6">
                <MapPin className="w-4 h-4 text-[hsl(var(--accent))]" />
                <h3 className="font-serif text-xl">{zone.title}</h3>
              </div>
              <ul className="space-y-2">
                {zone.cities.map((c) => (
                  <li key={c} className="text-sm text-foreground/80 flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--primary))]/80" />
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
